import React, {useMemo} from 'react';
import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';
import { useTable, usePagination, useSortBy } from 'react-table';

export default function TrainsTable({ data, selectedDate }) {
	const selectedDateAsString = dateFormat(selectedDate, "dd-mm-yyyy");
	const columns = useMemo(
		() => [
			{
				Header: 'Поезд №',
				accessor: 'number'
			},
			{
				Header: 'Маршрут следования',
				accessor: 'name'
			},
			{
				Header: 'Время отправления',
				accessor: 'departureTime'
			},
			{
				Header: 'Время прибытия',
				accessor: 'arrivalTime'
			}
			,
			{
				Header: 'Дни обращения',
				accessor: 'period'
			}
			,
			{
				Header: 'Тип электропоезда',
				accessor: 'trainType'
			}
		], []);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		page,
		canPreviousPage,
		canNextPage,
		pageCount,
		gotoPage,
		nextPage,
		previousPage,
		state: { pageIndex }
	} = useTable({
		columns, data,
		initialState: { pageIndex: 0, pageSize: 15 }
	}, useSortBy, usePagination);

	const printButton = () => {
		var mywindow = window.open('', 'PRINT', 'height=400,width=600');
		const styles = "<style>" +
			".schedule-table{width:100%}.schedule-table__head{background-color:#ededed}.schedule-table__head tr th:first-child{min-width:200px}.schedule-table__head tr th:nth-child(2){min-width:400px}.schedule-table__icon{margin-left:5px}.schedule-table__row{line-height:25px}.schedule-table__row:nth-child(2n){background-color:#ededed}"+
			"</style>";
		const element = document.getElementById("schedule-table");
		mywindow.document.write(`<html><head>${styles}</head><body>`);
		mywindow.document.write(element.outerHTML);
		mywindow.document.write('</body></html>');
		mywindow.document.close(); // necessary for IE >= 10
		mywindow.focus(); // necessary for IE >= 10*/
		mywindow.print();
		mywindow.close();

		return true;
	};

	return (
		<div>
			<table {...getTableProps()} className="schedule-table" id="schedule-table">
				<thead className="schedule-table__head">
				{headerGroups.map(headerGroup => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map(column => (
								<th {...column.getHeaderProps(column.getSortByToggleProps())}>
									{column.render('Header')}
									<span className="schedule-table__icon">
										{column.isSorted
											? column.isSortedDesc
												? <i className="fa fa-sort-up"/>
												: <i className="fa fa-sort-down"/>
											: <i className="fa fa-sort"/>}
									</span>
								</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
				{page.map((row, i) => {
						prepareRow(row);
						return (
							<tr {...row.getRowProps()} className={"schedule-table__row"}>
								{row.cells.map(cell => {
									return (
										<td {...cell.getCellProps()}>
											{cell.column.id === 'name' ?
												<Link to={`/trains/${cell.row.original.id}/${selectedDateAsString}`}>{cell.render('Cell')}</Link>
												: cell.render('Cell')}
										</td>
									);
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
			<div className="pagination">
				<button onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="pagination__button">{'<<'}</button>
				<button onClick={() => previousPage()} disabled={!canPreviousPage} className="pagination__button">{'<'}</button>
				<button onClick={() => nextPage()} disabled={!canNextPage} className="pagination__button">{'>'}</button>
				<button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} className="pagination__button">{'>>'}</button>
				<p className="pagination__info">Страница {pageIndex + 1} из {pageCount}</p>
			</div>
			<a onClick={printButton} className={"train-info__print-button"}>Распечатать</a>
		</div>
	);
}